export default {"src":"/_next/static/media/detached-farmhouses-icon.1139391f.svg","height":86,"width":108,"blurWidth":0,"blurHeight":0};